import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import "./tnc.scss"
import { useHistory } from 'react-router-dom';
import AxisButton from '../../components/button/button';
import Checkbox from '../../components/checkbox/checkbox';
import Text from '../../components/typography/typgraphy';
import { ARGO_DECLARATION, PROCEED, TNC, TNC_ACCEPTED } from '../../constants/messages';
import { TncState } from '../../core/reducers/tncReducer';
import { IErrorResponseType } from '../../constants/commonTypes';
import Loader from '../../components/loader/loader';
import { getTransactionIdFromURL } from '../../constants/utils';
import { APP_URLS } from '../../constants/constants';
import PageHeader from '../../components/pageHeader/pageHeader';
import { ProfileDetailsState, initialState as emptyTransactionState } from '../../core/reducers/profileDetailsReducer';
import { pushDataLayer, TNC_PAGELOAD_PARAM, TNC_PAGE_PROCEED, TNC_PAGELOAD_VPV, TNC_CHECKBOX_GA } from '../../constants/gaConstants';
import { TransactionState } from '../../core/reducers/transactionDetailsReducer';
import { AuthState } from '../../core/reducers/authReducer';


interface ITncProps {
  tncDetails: TncState;
  profileDetails: ProfileDetailsState;
  isLoading: boolean;
  isAuthenticated: boolean;
  errorTncSubmitConsent: IErrorResponseType;
  errorProfileDetails: IErrorResponseType;
  errorTncDetails: IErrorResponseType;
  submitTncConsent: (req: object) => void;
  getProfileDetails: () => void;
  getTnc: () => void;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const TnC: FunctionComponent<ITncProps> = (props) => {

  const { tncDetails, isAuthenticated, submitTncConsent, isLoading, profileDetails, errorTncSubmitConsent, getProfileDetails, errorProfileDetails, getTnc, errorTncDetails, transactionDetails, partnerData} = props;
  const [isChecked, setIsChecked] = useState(false)
  const [data, setData] = useState({} as TncState)
  const history = useHistory();
  const txnId = getTransactionIdFromURL()

  // GA on page load
  useEffect(() => {
    pushDataLayer(TNC_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    pushDataLayer(TNC_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
  }, [])

  // If Terms of Service is accepted then redirect to Generate / Validate OTP
  useEffect(() => {
    if (tncDetails.hasAccepted) {
      history.push(`${APP_URLS.OTP.replace(":txnId", txnId)}`);
    }
  }, [tncDetails, history, txnId])

  const handleCheckboxClick = () => {
    pushDataLayer(TNC_CHECKBOX_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    
    setIsChecked(!isChecked)
  }

  /**
  * Get Tnc details
  */
   useEffect(() => {
    function getDetails() {
      getTnc()
    }
    if (isAuthenticated) {
      getDetails()
    }
  }, [isAuthenticated, getTnc])

  /**
   * Set Tnc details to state
   */
   useEffect(() => {
    setData(tncDetails)
  }, [tncDetails])

  // Handle get TnC content error, redirect to error page
  useEffect(() => {
    if (errorTncSubmitConsent) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: {
          errorCode: errorTncSubmitConsent.code
        }
      })
    }
  }, [errorTncSubmitConsent, history, txnId])

  /*
  TODO: Remove related code to profile call, profile call looks like extra code
  useEffect(() => {
    if (isAuthenticated && (profileDetails === emptyTransactionState)) {
      getProfileDetails();
    }*/


  // If any Error arises, redirect to error page
  useEffect(() => {
    if (errorTncDetails) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: {
          errorCode: errorTncDetails.code
        }
      })
    }
  }, [errorTncDetails, history, txnId])


  // If any Error arises, redirect to error page
  /*useEffect(() => {
    if (errorProfileDetails) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: {
          errorCode: errorProfileDetails.code
        }
      })
    }
  }, [errorProfileDetails, history, txnId])*/

  // Submit the TOS Details acknowledgement
  const handleProceed = () => {
    let req = {
      docVersion: data.version
    }
    if (isAuthenticated) {
      pushDataLayer(TNC_PAGE_PROCEED(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
      submitTncConsent(req)
    }
  }


  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className="tnc-container">
        <PageHeader className="page-header" />
        <div className="page-header-wrapper">
          <div className="tnc-wrapper">
            <div className="tnc-header">
              <Text fontWeight={700} className="header">{TNC}</Text>
              <Text className="sub-header">{ARGO_DECLARATION}</Text>
            </div>
            <div className="tnc-content-wrapper">
              <div dangerouslySetInnerHTML={{ __html: data.fileContent }} />
              <div className="checkbox">
                <Checkbox onChange={handleCheckboxClick} required={true} checked={isChecked} />
                <Text className="checkbox-text">{TNC_ACCEPTED}</Text>
              </div>
            </div>
            <div className="submit-btn-container btn-web">
              <AxisButton onClick={() => handleProceed()} disabled={!isChecked} disableElevation customStyle={"submit-btn-primary"} variant="contained">
                <Text className={"submit-btn-text"}>{PROCEED}</Text>
              </AxisButton>
            </div>
          </div>
          <div className="submit-btn-container btn-mob">
            <AxisButton onClick={() => handleProceed()} disabled={!isChecked} disableElevation customStyle={"submit-btn-primary"} variant="contained">
              <Text className={"submit-btn-text"}>{PROCEED}</Text>
            </AxisButton>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default TnC;